import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type PollUserPermissionsQueryVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type PollUserPermissionsQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', default_role: string, updated_at: string, users_usertofeatures: Array<{ __typename?: 'usertofeatures', feature: { __typename?: 'features', name: string, config: object } }> } | null };


export const PollUserPermissionsDocument = gql`
    query pollUserPermissions($userId: bigint!) {
  users_by_pk(id: $userId) {
    default_role
    updated_at
    users_usertofeatures {
      feature {
        name
        config
      }
    }
  }
}
    `;

/**
 * __usePollUserPermissionsQuery__
 *
 * To run a query within a React component, call `usePollUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollUserPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePollUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<PollUserPermissionsQuery, PollUserPermissionsQueryVariables> & ({ variables: PollUserPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>(PollUserPermissionsDocument, options);
      }
export function usePollUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>(PollUserPermissionsDocument, options);
        }
// @ts-ignore
export function usePollUserPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>;
export function usePollUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<PollUserPermissionsQuery | undefined, PollUserPermissionsQueryVariables>;
export function usePollUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>(PollUserPermissionsDocument, options);
        }
export type PollUserPermissionsQueryHookResult = ReturnType<typeof usePollUserPermissionsQuery>;
export type PollUserPermissionsLazyQueryHookResult = ReturnType<typeof usePollUserPermissionsLazyQuery>;
export type PollUserPermissionsSuspenseQueryHookResult = ReturnType<typeof usePollUserPermissionsSuspenseQuery>;
export type PollUserPermissionsQueryResult = Apollo.QueryResult<PollUserPermissionsQuery, PollUserPermissionsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/auth/queries/pollUserPermissions.query.gql}
 */
export async function pollUserPermissions(
  variables: PollUserPermissionsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<PollUserPermissionsQuery['users_by_pk']>
export async function pollUserPermissions(
  variables: PollUserPermissionsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<PollUserPermissionsQuery>
export async function pollUserPermissions(
  variables: PollUserPermissionsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<PollUserPermissionsQuery['users_by_pk'] | PollUserPermissionsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<PollUserPermissionsQuery>(
    PollUserPermissionsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.users_by_pk
}